import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './Page1.css';

function Page1() {
  const navigate = useNavigate();

  // ✅ Initialize with default values
  const [selectedHostTeam, setSelectedHostTeam] = useState('');
  const [selectedVisitorTeam, setSelectedVisitorTeam] = useState('');
  const [selectedTossWinner, setSelectedTossWinner] = useState('');
  const [selectedOpt, setSelectedOpt] = useState('');
  const [overs, setOvers] = useState('');
const startMatch = async () => {
  console.log("Start clicked!"); // check click works

  if (!selectedHostTeam || !selectedVisitorTeam || !selectedTossWinner || !selectedOpt || !overs) {
    alert("Please fill all fields before starting the match.");
    return;
  }

  const matchid = Date.now();
  localStorage.setItem('match_id', matchid);

  try {
    const response = await fetch('https://nammateam.onrender.com/api/match/create', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        matchid,
        team1: selectedHostTeam,
        team2: selectedVisitorTeam,
        tosswinner: selectedTossWinner,
        opt: selectedOpt,
        overs: Number(overs),
      }),
    });

    const data = await response.json();
    console.log("Server response:", data);

    if (response.ok) {
      navigate('/players');
    } else {
      console.error('Server error:', data.error);
    }
  } catch (error) {
    console.error('Error starting match:', error);
  }
};

  return (
    <div className="total">
      <h2>Teams</h2>

      <div className="team">
        <label>Host Team</label>
        <input
          type="text"
          placeholder="Enter Host Team"
          className="team-input"
          value={selectedHostTeam}
          onChange={(e) => setSelectedHostTeam(e.target.value)}
        />
        <hr />
        <label>Visitor Team</label>
        <input
          type="text"
          placeholder="Enter Visitor Team"
          className="team-input"
          value={selectedVisitorTeam}
          onChange={(e) => setSelectedVisitorTeam(e.target.value)}
        />
      </div>

      <h2>Toss Won By?</h2>
      <div className="radio-group">
        <input
          type="radio"
          id="host"
          name="toss"
          value={selectedHostTeam}
          checked={selectedTossWinner === selectedHostTeam}
          onChange={(e) => setSelectedTossWinner(e.target.value)}
        />
        <label htmlFor="host" className="radio-label green">
          {selectedHostTeam || 'Host'}
        </label>

        <input
          type="radio"
          id="visitor"
          name="toss"
          value={selectedVisitorTeam}
          checked={selectedTossWinner === selectedVisitorTeam}
          onChange={(e) => setSelectedTossWinner(e.target.value)}
        />
        <label htmlFor="visitor" className="radio-label yellow">
          {selectedVisitorTeam || 'Visitor'}
        </label>
      </div>

      <h2>Opted to?</h2>
      <div className="radio-group">
        <input
          type="radio"
          id="bat"
          name="opt"
          value="bat"
          checked={selectedOpt === 'bat'}
          onChange={(e) => setSelectedOpt(e.target.value)}
        />
        <label htmlFor="bat" className="radio-label purple">Bat</label>

        <input
          type="radio"
          id="bowl"
          name="opt"
          value="bowl"
          checked={selectedOpt === 'bowl'}
          onChange={(e) => setSelectedOpt(e.target.value)}
        />
        <label htmlFor="bowl" className="radio-label green">Bowl</label>
      </div>

      <h2>Overs?</h2>
      <input
        type="number"
        className="overs-input"
        placeholder="Eg. 8, 12, 20"
        value={overs}
        onChange={(e) => setOvers(e.target.value)}
      />

      <div className="team4">
        <button onClick={startMatch}>Start Match</button>
      </div>
    </div>
  );
}

export default Page1;
